import { useCallback, useState, useEffect } from 'react'
import { useUserService } from '.'
import { User } from '../services/user/user'

interface CurrentUser {
  isLoading: boolean
  user: User
}

export const useGetCurrentUser = (): CurrentUser => {
  const userService = useUserService()

  const [userState, setUserState] = useState({
    user: userService.currentUser,
    isLoading: userService.currentUser.isNone,
  })

  const loadUser = useCallback(async () => {
    let user = userService.currentUser
    try {
      user = await userService.initialLoad()
    } catch (e) {
      user = User.None
    } finally {
      setUserState({ isLoading: false, user })
    }
  }, [userService])

  useEffect(() => {
    // If user has been set by facade, then there is no need to load the user
    if (userService.currentUser.isNone) {
      loadUser()
    }
  }, [loadUser, userService.currentUser.isNone])

  return userState
}
